import type { InputSink, MouseButton } from './input';
import type { App } from './app';
import type { Renderer } from '../gfx/renderer';

/** A full-screen state (title, menus, lobby, game). Screens are input sinks while active. */
export abstract class Screen implements InputSink {
  app!: App;
  /** Load assets; called before the screen becomes visible (the app shows a fade meanwhile). */
  async load(): Promise<void> {}
  enter(): void {}
  leave(): void {}
  update(_dt: number): void {}
  abstract render(r: Renderer): void;
  /** Which cursor to show (`null` hides it). */
  cursor(): CursorKind | null {
    return 'hand';
  }
  onMouseDown?(x: number, y: number, button: MouseButton, e: MouseEvent): boolean | void;
  onMouseUp?(x: number, y: number, button: MouseButton, e: MouseEvent): boolean | void;
  onMouseMove?(x: number, y: number, e: MouseEvent): void;
  onWheel?(dy: number, e: WheelEvent): void;
  onKeyDown?(e: KeyboardEvent): boolean | void;
  onKeyUp?(e: KeyboardEvent): void;
  onText?(text: string): void;
}

export type CursorKind = 'hand' | 'press' | 'grasp' | 'buy' | 'sell' | 'identify' | 'none';
